const findFirstGameOfRound = roundGames => {
  return roundGames.find(game => game.statusShort !== 'PST')
}

export { findFirstGameOfRound }
